// src/components/Hero/Hero.js
import React, { useState, useEffect } from "react";
import "./Hero.css";
import HeroSearch from "./HeroSearch";

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: "Luxury Villa",
      subtitle: "Live Your Dreams",
      description:
        "Cover the perfect blend of luxury and comfort in our exclusive properties designed for modern living.",
      image:
        "https://images.unsplash.com/photo-1613977257363-707ba9348227?auto=format&fit=crop&w=2070&q=80",
    },
    {
      id: 2,
      title: "Modern Office",
      subtitle: "Make Better Work",
      description:
        "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
      image:
        "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=2071&q=80",
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => setCurrentSlide(index);

  return (
    <section className="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${index === currentSlide ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="container">
              <div className="hero-content">
                <div className="hero-text">
                  <h1 className="hero-title">{slide.title}</h1>
                  <h2 className="hero-subtitle">{slide.subtitle}</h2>
                  <p className="hero-description">{slide.description}</p>
                  <a href="#" className="btn btn-hero1">
                    LEARN MORE
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ⭐ Property Search Bar */}

      {/* Slider Dots */}
      <div className="slider-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentSlide ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
